function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var MarriageTemplate = require('./marriage.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var MarriageOverlay = /*#__PURE__*/function () {
  function MarriageOverlay(app, mod) {
    _classCallCheck(this, MarriageOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
    this.selected = [];
    this.bonus = 0;
    this.roll = 0;
  }
  return _createClass(MarriageOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "renderApproveDivorce",
    value: function renderApproveDivorce() {
      var his_self = this.mod;
      this.render();
      document.querySelector('.marriage-overlay .help').innerHTML = "Annulling Henry VIII's Marriage prevents Papal-Hapsburg Alliance for one turn...";
      this.app.browser.addElementToSelector('<div class="status"></div>', '.marriage-overlay');
      this.app.browser.addElementToSelector('<div class="controls"></div>', '.marriage-overlay');
      var msg = "Approve Henry VIII's Divorce?";
      var html = [];
      html.push({
        id: 'approve',
        label: 'approve divorce'
      });
      html.push({
        id: 'disapprove',
        label: 'do not approve'
      });
      his_self.game.status = msg;
      his_self.hud.updateStatus(msg);
      his_self.hud.updateCards([]);
      his_self.hud.updateMenu(html, function (user_choice) {
        var action = user_choice;
        if (action === 'approve') {
          his_self.addMove('advance_henry_viii_marital_status');
          his_self.addMove("SETVAR\tstate\thenry_viii_pope_approves_divorce\t1");
          his_self.addMove("NOTIFY\tThe Papacy accedes to Henry VIII's request for a divorce.");
          his_self.endTurn();
        }
        if (action === 'disapprove') {
          his_self.endTurn();
          his_self.hide();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var his_self = this.mod;
      this.overlay.show(MarriageTemplate());
      if (msg != '') {
        document.querySelector('.marriage-overlay .help').innerHTML = msg;
      }
      for (var i = 0; i < 7; i++) {
        tileqs = ".marriage-overlay .tile".concat(i + 1);
        var obj = document.querySelector(tileqs);
        obj.classList.add("henry_viii_marital_status");
        obj.classList.add("henry_viii_marital_status".concat(i + 1));
        if (i == his_self.game.state.henry_viii_marital_status) {
          obj.classList.add('active');
        }
        if (i > his_self.game.state.henry_viii_marital_status) {
          obj.classList.add("show_wife");
        }
      }
    }
  }]);
}();
module.exports = MarriageOverlay;